import {Component, Input, OnInit} from '@angular/core';
import {Project, Service, ServiceOrder} from '@app/shared';
import {GlobalValuesService} from '../../../../core/services/global-values.service';
import {Router} from '@angular/router';
import {deepGet, ScreenService} from '@app/core';

@Component({
  selector: 'app-global-search-result-card',
  standalone: false,

  templateUrl: './global-search-result-card.component.html',
  styleUrl: './global-search-result-card.component.less'
})
export class GlobalSearchResultCardComponent implements OnInit {
  @Input() project: Project | undefined;
  @Input() service: Service | undefined;
  @Input() serviceOrder: ServiceOrder | undefined;
  @Input() isSmallMode: boolean = false;
  @Input() searchvalue: string = '';

  deepGet = deepGet;

  constructor(
    public globalValuesService: GlobalValuesService,
    private router: Router,
    public screenService: ScreenService,
  ) {
  }

  selectedProperty: { path: string, label: string } | null = null;

  ngOnInit() {
    if (this.serviceOrder && this.searchvalue) {
      const searchValue = this.searchvalue.toLowerCase();

      // Define the properties to check with their paths and labels
      const properties = [
        { path: 'reference', label: 'Referencia' },
        { path: 'referenceCEC', label: 'Ref. CEC' },
        { path: 'referenceCommercial', label: 'Ref. Comercial' },
        { path: 'projectContainer.containerRef', label: 'Nº Contenedor' },
        { path: 'mbl', label: 'MBL' },
        { path: 'hbl', label: 'HBL' }
      ];

      // Find the first property that matches the search value
      this.selectedProperty = properties.find(prop => {
        const value = this.deepGet(this.serviceOrder, prop.path)?.toString().toLowerCase();
        return value && value.includes(searchValue);
      }) || null;
    }
  }

  highlightMatch(text: string | null | undefined): string {
    if (!text || !this.searchvalue) return text || '';

    const searchValue = this.searchvalue.toLowerCase();
    const textLower = text.toString().toLowerCase();
    const matchIndex = textLower.indexOf(searchValue);

    if (matchIndex === -1) return text.toString();

    const beforeMatch = text.substring(0, matchIndex);
    const matchText = text.substring(matchIndex, matchIndex + searchValue.length);
    const afterMatch = text.substring(matchIndex + searchValue.length);

    return `${beforeMatch}<strong>${matchText}</strong>${afterMatch}`;
  }

  navigateToDetail() {
    if (this.serviceOrder) {
      return; // Do nothing if serviceOrder exists
    }

    if (this.project) {
      this.router.navigate(['/projects/detail', this.project.id]).then();
    } else if (this.service) {
      this.router.navigate(['/projects/detail', this.service.projectId, 'service', this.service.id]).then();
    }
  }

  navigateToSO(isAdministracion: boolean) {
    const path = isAdministracion
      ? '/administration'
      : `/projects/detail/${this.serviceOrder!.service!.project?.id || 0}/service/${this.serviceOrder!.service!.id}`;

    window.location.href = path + `?order=${this.serviceOrder!.reference}`
  }

}
